(() => {
  function switchLangHandler(new_lang) {
    const url = new URL(window.location.href);
    url.pathname = replacePathname(url.pathname, new_lang);
    window.location.href = url.toString();
  }

  function replacePathname(pathname, new_lang) {
    // remove old prefix
    pathname = pathname.replace(/^\/en/, "");
    pathname = pathname.replace(/^\/fr/, "");
    // add new prefix
    return "/" + new_lang + "/" + pathname;
  }

  window.switchLangHandler = switchLangHandler;
})();
